export default __webpack_public_path__ + "static/media/np.11fdc729.svg";